import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query GetRegions {
    getRegions {
      _id
      name
    }
  }
`;
